export {TelephonyModule} from './telephonyModule';
